import { PageHeader } from 'design-system';

import { useRouteMeta } from '@/shared/pageTitle';

/**
 * The fixed application topbar: a `Section / Title` breadcrumb resolved from
 * route metadata.
 */
const AppTopBar = () => {
  const { title, section } = useRouteMeta();

  return (
    <PageHeader
      title={title}
      section={section}
    />
  );
};

export default AppTopBar;
